var map = {
	"./demos/attachments/index.ts": 15945,
	"./demos/basic/index.ts": 83704,
	"./demos/customContent/index.ts": 26776,
	"./demos/loading/index.ts": 88440,
	"./demos/shape/index.ts": 87860,
	"./demos/streaming/index.ts": 34262,
	"./demos/typing/index.ts": 47075,
	"./demos/variant/index.ts": 43095,
	"./demos/withThink/index.ts": 55,
	"./demos/xmarkdown/index.ts": 88604
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9584;